module.exports = __webpack_public_path__ + "static/media/4wallsofarith.11edfc2c.jpg";